import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

const locales = { // 引入zh.json以及en.json
    ft: require('./ft.json'),
    zn: require('./zn.json'),
    en: require('./en.json'),
}

const i18n = new VueI18n({ // 创建带有选项的 VueI18n 实例
    locale: "ft",
    messages : locales // 语言包，上边创建的json文件
})

export default i18n;    


// WEBPACK FOOTER //
// ./src/lang/index.js